module.exports = __webpack_public_path__ + "media/Images/icon-piggy-purple-o-cfa3777126424536a7c785848d2834cb.svg";